import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=7dd6d44f&scoped=true&"
import script from "./Transfers.vue?vue&type=script&lang=js&"
export * from "./Transfers.vue?vue&type=script&lang=js&"
import style0 from "./Transfers.vue?vue&type=style&index=0&id=7dd6d44f&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd6d44f",
  null
  
)

export default component.exports